import React from 'react';
import styled from 'styled-components/macro';

import ChartsTabsHeader from '../shared/ChartsTabsHeader';
import DSPContentLoader from 'components/data-containers/PositionsTable/TableControls/ContentLoader';
import LoadingBar from 'components/styled/LoadingBar/LoadingBar';

import { ChartTypes } from 'types/shared';
import { TabsWrapper } from '../styles';

const LoadingBarWrapper = styled('div')`
  height: 2px;
`;

interface ITabsSkeletonLoaderProps {
  isLargeScreen: boolean;
  chartPage: ChartTypes;
  title: string;
  isLoadingCustomers: boolean;
}

const TabsSkeletonLoader: React.FC<ITabsSkeletonLoaderProps> = (props) => {
  const { isLargeScreen, chartPage, title, isLoadingCustomers } = props;

  return (
    <>
      <LoadingBarWrapper>
        <LoadingBar loading={isLoadingCustomers} />
      </LoadingBarWrapper>

      <TabsWrapper>
        <ChartsTabsHeader
          isLargeScreen={isLargeScreen}
          chartPage={chartPage}
          title={title}
        />

        <DSPContentLoader isLargeScreen={isLargeScreen} />
      </TabsWrapper>
    </>
  );
};

export default TabsSkeletonLoader;
